import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
// @ts-expect-error JS file
import { DEAL_AMOUNT_CALCULATOR_PROPERTY } from 'crm_data/constants/PortalSettingsKeys';
import { meetingCardProperties } from '../../constants/apiResponses';
import { DEBOUNCE_TIME } from '../../constants/timeouts';
import { pluralTypeToId, toObjectTypes } from '../../constants/types';
import baseHttpClient from '../../utils/apiClient';
import { genarateCalculatePropertiesBody } from '../../utils/lineItems';
export const fetchCardProperties = ({
  objectType
}) => objectType === toObjectTypes.meeting ? Promise.resolve(meetingCardProperties) : new Promise((resolve, reject) => {
  baseHttpClient.get(`${getFullUrl('app-api')}/crm-record-cards/v2/cards/property/${objectType}`).then(data => {
    const result = data.results.find(el => el.cardType === 'PROPERTIES');
    return result ? result.propertyNames : [];
  }).then(defaultProperties => baseHttpClient.get(`${getFullUrl('app-api')}/crm-record-cards/v1/association-cards/${objectType}/summary-properties`).then(response => ({
    defaultProperties,
    associationCardProperties: {
      primaryProperties: response.primaryProperties,
      secondaryProperties: response.secondaryProperties,
      blocklistedSecondaryProperties: response.blocklistedSecondaryProperties
    }
  }))).then(resolve).catch(err => reject(err));
});
export const fetchPropertiesDetails = ({
  objectType,
  data
}) => baseHttpClient.post(`${getFullUrl('app-api')}/crm/v3/properties/${objectType}/batch/read`, {
  data
});
export const fetchObjectCreationFields = objectTypeId => baseHttpClient.get(`
${getFullUrl('app-api')}/crm-object-fields/v2/fields/${objectTypeId}/creator`);
export const fetchExternalOptions = ({
  query = '',
  referenceType,
  offset = 0,
  limit = 25,
  typeId = pluralTypeToId.contacts,
  delay
}) => baseHttpClient.post(`${getFullUrl('app-api')}/external-options/v3/pagedFetch/${referenceType}`, Object.assign({
  data: {
    referenceType,
    portalId: PortalIdParser.getPortalIdFromPath(),
    objectType: typeId,
    offset,
    limit,
    searchQuery: query
  }
}, delay && {
  delay
}));
export const validateProperty = ({
  crmObjectType,
  data
}) => baseHttpClient.post(`${getFullUrl('app-api')}/property-validation/v1/property-validation/${crmObjectType}/extended`, {
  data,
  delay: DEBOUNCE_TIME
});
export const getCreatorAssociationPropertiesDefinitions = objectTypeId => baseHttpClient.get(`${getFullUrl('app-api')}/associations/v1/definitions/${objectTypeId}`);
export const calculatePropertiesRequest = payload => baseHttpClient.post(`${getFullUrl('app-api')}/inbounddb-objects/v1/calculation-preview/calculated-properties/batch`, {
  data: genarateCalculatePropertiesBody(payload)
});
export const getMultiCurrencies = () => baseHttpClient.get(`${getFullUrl('app-api')}/multi-currency/v2/currencies/information`);
export const getDealAmountSettings = () => baseHttpClient.get(`${getFullUrl('app-api')}/commerce-products-settings/v1/settings/${DEAL_AMOUNT_CALCULATOR_PROPERTY}`);